/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import { isString } from '@braindate/util/lib/type';

import styles from './Avatar.style';

import avatarSizes from './setting/avatarSizes';
import ResponsivePicture from '@braindate/ui/lib/component/ResponsivePicture';

import type { Picture } from '@braindate/domain/lib/base/type';
import type { AvatarProps } from './type/avatarTypes';

type Props = AvatarProps & { src: string | Picture };

const useStyles = createUseThemeStyles(styles);

// $FlowIssue
const Avatar = ({ layoutClass, variant, alt, src }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ variant });

  const rootClasses = classNames(classes.root, layoutClass);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const props = {
    alt,
  };

  if (isString(src)) {
    return <img {...props} className={rootClasses} src={src} />;
  }

  return (
    <ResponsivePicture
      {...props}
      alt={alt}
      layoutClass={rootClasses}
      picture={src}
      displayWidth={avatarSizes[variant]}
    ></ResponsivePicture>
  );
};

// Make variants available
export * from './setting/avatarVariants';

export default React.memo<Props>(Avatar);
